import { cache } from '@/container/apollo-client/cache';
import {
  KycVerificationSessionsStatus,
  useActiveWorkspacesQuery,
  useKycVerificationSessionSubscription,
} from '@/types/generated/graphql';
import { cacheOnly } from '@shared/constants';
import { notification } from 'antd';

export function useKYCVerification() {
  const { data } = useActiveWorkspacesQuery(cacheOnly);
  const workspaces = data?.activeWorkspaces?.edges ?? [];
  const currentWorkspace = workspaces.find((ws) => ws?.isCurrent) || workspaces[0];

  useKycVerificationSessionSubscription({
    onData: ({ data }) => {
      const workspaceId = data?.data?.kycVerificationSession?.workspaceId as number;
      const status = data?.data?.kycVerificationSession?.status as KycVerificationSessionsStatus;

      // ignore if logged in to different workspace
      if (currentWorkspace?.id !== workspaceId) return;

      switch (status) {
        case 'approved':
          onApprove(workspaceId);
          return;

        case 'declined':
          onDecline();
          return;
      }
    },
  });
}

function onApprove(workspaceId: number) {
  // open notification until manual closure;
  notification.success({ message: 'KYC verification has been approved', duration: 0 });

  const workspaceCacheId = cache.identify({
    __typename: 'Workspace',
    id: workspaceId,
  });

  if (!workspaceCacheId) return;

  cache.modify({
    id: workspaceCacheId,
    fields: {
      kycVerified() {
        return true;
      },
    },
  });
}
function onDecline() {
  // open notification until manual closure;
  notification.error({ message: 'KYC verification has been declined', duration: 0 });
}
